import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface SlotApi {
  target: HTMLElement | null;
  setTarget: (element: HTMLElement | null) => void;
}

const HeaderSlotContext = createContext<SlotApi | null>(null);

export function HeaderSlotProvider({ children }: { children: ReactNode }) {
  const [target, setTarget] = useState<HTMLElement | null>(null);
  const value = useMemo(() => ({ target, setTarget }), [target]);
  return <HeaderSlotContext.Provider value={value}>{children}</HeaderSlotContext.Provider>;
}

/** Место в шапке страницы, куда экран может положить своё. */
export function HeaderSlotTarget({ className }: { className?: string }) {
  const slot = useContext(HeaderSlotContext);
  return <div ref={slot?.setTarget} className={className} />;
}

/**
 * Рисует содержимое в шапке страницы. Портал, а не подъём на страницу: содержимое
 * остаётся в дереве экрана со всем его состоянием. Вне PageShell рисует на месте.
 */
export function HeaderSlot({ children }: { children: ReactNode }) {
  const slot = useContext(HeaderSlotContext);
  if (!slot) return <>{children}</>;
  return slot.target ? createPortal(children, slot.target) : null;
}
